export default "__VITE_ASSET__BcjsCixx__"